import 'react';
import { css } from 'reakit/styled';
import { palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import { isInteractive } from '../Button/styled.js';
var SelectMenu = {
  ActionButton: {
    base: css(["height:", "rem;"], space(2))
  },
  Button: {
    base: css(["border:1px solid #bdbdbd;color:", ";height:", "rem;padding:0.4em 1.8em 0.4em 0.6em;text-transform:unset;", ";"], palette('text'), space(11), function (props) {
      return isInteractive(props) && css(["&:hover{background-color:unset;color:unset;}&:focus{background-color:unset;color:unset;border:1px solid ", ";outline:unset;box-shadow:", " 0px 0px 0px 1px !important;}"], palette('primary'), palette('primary'));
    })
  },
  LoadingSpinner: {
    base: css(["top:13px;"])
  },
  Tag: {
    base: css(["border-radius:0px;background-color:", ";& button{&:hover{background-color:", ";}&:focus,&:hover:focus{background-color:", ";box-shadow:inset ", " 0px 0px 0px 2px;outline-color:", ";}}"], palette('secondary'), palette('secondary700'), palette('secondary700'), palette('secondary'), palette('secondary'))
  }
};
export default SelectMenu;